import { AUTH_LS_KEY, AUTH_TTL_DAYS, AUTH_URL, AUTH_TOKEN } from '@/config';

export function readAuth() {
  try {
    const raw = localStorage.getItem(AUTH_LS_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.createdAt) {
      localStorage.removeItem(AUTH_LS_KEY);
      return null;
    }
    const ttlMs = AUTH_TTL_DAYS * 24 * 60 * 60 * 1000;
    if (Date.now() - Number(data.createdAt) > ttlMs) {
      localStorage.removeItem(AUTH_LS_KEY);
      return null;
    }
    return data;
  } catch (e) {
    console.error('Error leyendo auth:', e);
    localStorage.removeItem(AUTH_LS_KEY);
    return null;
  }
}

function setCookie(name, value, days) {
  try {
    const ms = days * 24 * 60 * 60 * 1000;
    const expires = new Date(Date.now() + ms).toUTCString();
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  } catch {
    // no-op
  }
}

export function writeAuth({ nombre, pin }) {
  const payload = { nombre, pin, createdAt: Date.now() };
  localStorage.setItem(AUTH_LS_KEY, JSON.stringify(payload));
  // "cookie" de vida (ligera). No es la fuente principal; solo ayuda a depurar.
  setCookie(AUTH_LS_KEY, '1', AUTH_TTL_DAYS);
  return payload;
}

export async function verifyPin({ nombre, pin }) {
  const response = await fetch(AUTH_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'token-verify-permision': AUTH_TOKEN,
    },
    body: JSON.stringify({ nombre, pin }),
  });

  if (!response.ok) {
    throw new Error('Error HTTP en verificación de pin');
  }

  return response.json();
}

export function clearAuth() {
  localStorage.removeItem(AUTH_LS_KEY);
  setCookie(AUTH_LS_KEY, '0', -1);
}
